import React, { useState, useEffect, useRef, useMemo } from 'react';

var useComponentWillMount = function useComponentWillMount(func) {
  useMemo(func, []);
};

export default useComponentWillMount;